import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    '& svg': {
      marginRight: 6,
      verticalAlign: 'text-bottom'
    }
  }
}))

export default useStyles
